<div class="main-card p-3 fill-column">
    <div class="flex align-items-center justify-content-between gap-3 mb-3 flex-wrap">
      <div class="search-filters flex align-items-center gap-3 flex-wrap">
        <div class="border-solid border-round-md border-1 p-1 border-300">
          <i (click)="search()" class="pi mr-2 cursor-pointer text-primary" [ngClass]="isSearching ? 'pi-spinner pi-spin' : 'pi-search'"></i>
          <input
            class="p-1 border-none outline-none text-base question-search"
            type="text"
            placeholder="Wyszukaj pytanie lub nr pytania"
            [(ngModel)]="searchValue"
            (input)="onSearchInput()"
            (keyup.enter)="search()"
            data-clarity-unmask="true"
          />
        </div>
        <p-dropdown
          [options]="translationFilterOptions"
          [(ngModel)]="translationFilter"
          (onChange)="applyFilters()"
          optionLabel="label"
          optionValue="value"
          styleClass="translation-filter"
          data-clarity-unmask="true"
        ></p-dropdown>
      </div>
      <div class="question-actions flex flex-wrap md:flex-nowrap align-items-center gap-3">
        <p-button [loading]="loadingDownload" [disabled]="loadingDownload" [outlined]="true" label="Pobierz" icon="pi pi-download" (onClick)="downloadAll()" data-clarity-unmask="true"/>
        <p-splitButton [outlined]="true" label="Synchronizuj bazę" (onClick)="syncQuestions()" [model]="splitButtonItems" />
        <p-button label="Dodaj pytanie" icon="pi pi-plus" (onClick)="openAddQuestionDialog()" data-clarity-unmask="true"/>
      </div>
    </div>
    <p-tabView
      styleClass="tabview-lg"
      [scrollable]="true"
      (onChange)="handleTabSwitch($event)"
      [activeIndex]="selectedTabIndex"
    >
      <p-tabPanel header="Wszystkie pytania">
        <fas-services-table class="table-height" scrollHeight="flex"
        #dt
        [value]="questionsList"
        [rows]="currentRows"
        [columns]="questionColumns"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        [first]="currentFirst"
        [paginator]="true"
        [showCheckbox]="false"
        [loading]="isLoading"
        (pageChange)="setCurrentPosition($event)"
        [showCurrentPageReport]="true"
        [showFooterPageReport]="false"
        [globalFilterFields]="[
        'questionNumber',
        'questionCategory',
        'examCategories',
        'lastUpdated',
        'points'
      ]"
      >
        <ng-template #reviewCell let-q>
          <ng-container *ngTemplateOutlet="reviewButtons; context: { $implicit: q }"></ng-container>
        </ng-template>
      </fas-services-table>
      </p-tabPanel>

      <p-tabPanel header="Pytnia uzupełnione">
        <fas-services-table class="table-height" scrollHeight="flex"
        [value]="questionsNoEmptyCategoryList"
        [rows]="currentRows"
        [columns]="questionColumns"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        [first]="currentFirst"
        [paginator]="true"
        [showCheckbox]="false"
        [loading]="isLoading"
        [showCurrentPageReport]="true"
        [showFooterPageReport]="false"
        [globalFilterFields]="[
        'questionNumber',
        'questionCategory',
        'examCategories',
        'lastUpdated',
        'points'
      ]"
      >
        <ng-template #reviewCell let-q>
          <ng-container *ngTemplateOutlet="reviewButtons; context: { $implicit: q }"></ng-container>
        </ng-template>
      </fas-services-table>
      </p-tabPanel>

      <p-tabPanel header="Pytania do uzupełnienia">
        <fas-services-table class="table-height" scrollHeight="flex"
        [value]="questionsEmptyCategoryList"
        [rows]="currentRows"
        [columns]="questionColumns"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        [first]="currentFirst"
        [paginator]="true"
        [showCheckbox]="false"
        [loading]="isLoading"
        [showCurrentPageReport]="true"
        [showFooterPageReport]="false"
        [globalFilterFields]="[
        'questionNumber',
        'questionCategory',
        'examCategories',
        'lastUpdated',
        'points'
      ]"
      >
        <ng-template #reviewCell let-q>
          <ng-container *ngTemplateOutlet="reviewButtons; context: { $implicit: q }"></ng-container>
        </ng-template>
      </fas-services-table>
      </p-tabPanel>

      <p-tabPanel [header]="reviewTabHeader()">
        <p class="text-sm text-600 mt-0 mb-3 review-hint">
          Pytania oznaczone przez redakcję lub po imporcie katalogu ministerstwa (zmieniony klucz odpowiedzi, brak pliku, zmieniona treść).
          Po sprawdzeniu kliknij „Sprawdzone” – pytanie znika z tej listy, a w szczegółach zostaje informacja, kto i kiedy je sprawdził.
        </p>
        <fas-services-table class="table-height" scrollHeight="flex"
        [value]="questionsToReviewList"
        [rows]="currentRows"
        [columns]="reviewColumns"
        [rowsPerPageOptions]="[10, 25, 50, 100]"
        [paginator]="true"
        [showCheckbox]="false"
        [loading]="isLoading"
        [showCurrentPageReport]="true"
        [showFooterPageReport]="false"
        customResultsName="pytań do sprawdzenia"
        [globalFilterFields]="[
        'questionNumber',
        'questionCategory',
        'examCategories',
        'reviewNote'
      ]"
      >
        <ng-template #reviewCell let-q>
          <ng-container *ngTemplateOutlet="reviewButtons; context: { $implicit: q }"></ng-container>
        </ng-template>
      </fas-services-table>
      </p-tabPanel>

      <!-- Rendered only when opened, so the status request of the DeepL run goes out when the operator looks at it. -->
      <p-tabPanel [header]="ministryTabHeader()">
        <ng-template pTemplate="content">
          <app-machine-translation
            [allQuestions]="withoutMinistryUaList"
            [questions]="ministryViewList"
            [loading]="isLoading"
            [view]="ministryView"
            (viewChange)="onMinistryViewChange($event)"
            (openDetails)="openMinistryQuestionDetails($event)"
            (translationFinished)="inicializeQuestionList()"
          ></app-machine-translation>
        </ng-template>
      </p-tabPanel>

      <!-- Rendered only when opened, so the status request goes out when the operator looks at it. -->
      <p-tabPanel header="Media">
        <ng-template pTemplate="content">
          <app-media-import></app-media-import>
        </ng-template>
      </p-tabPanel>
    </p-tabView>
</div>

<!-- One cell for every table: a green tick to clear the flag, a grey flag to raise it. -->
<ng-template #reviewButtons let-q>
  @if (q.needsReview) {
    <p-button
      label="Sprawdzone"
      icon="pi pi-check"
      size="small"
      severity="success"
      [outlined]="true"
      [loading]="isReviewPending(q)"
      [pTooltip]="q.reviewNote ? 'Powód: ' + q.reviewNote : 'Oznacz jako sprawdzone'"
      tooltipPosition="left"
      (onClick)="markReviewed(q)"
      data-clarity-unmask="true"
    />
  } @else {
    <p-button
      icon="pi pi-flag"
      size="small"
      severity="secondary"
      [text]="true"
      [loading]="isReviewPending(q)"
      pTooltip="Oznacz do sprawdzenia"
      tooltipPosition="left"
      (onClick)="openReviewDialog(q)"
      data-clarity-unmask="true"
    />
  }
</ng-template>

<p-dialog
  header="Oznacz pytanie do sprawdzenia"
  [(visible)]="reviewDialogVisible"
  [modal]="true"
  [draggable]="false"
  [style]="{ width: '520px' }"
>
  @if (reviewDialogQuestion; as q) {
    <div class="text-sm mb-3">
      <span class="font-semibold">Pytanie nr {{ q.questionNumber }}:</span> {{ q.question }}
    </div>
    <label class="block text-sm mb-1" for="reviewNote">Powód (opcjonalnie)</label>
    <textarea
      id="reviewNote"
      pInputTextarea
      rows="3"
      class="w-full"
      [(ngModel)]="reviewNote"
      placeholder="np. zmieniony klucz odpowiedzi, brak zdjęcia, wyjaśnienie do poprawy"
      data-clarity-unmask="true"
    ></textarea>
  }
  <ng-template pTemplate="footer">
    <p-button label="Anuluj" [text]="true" (onClick)="reviewDialogVisible = false" />
    <p-button label="Oznacz do sprawdzenia" icon="pi pi-flag" (onClick)="confirmReview()" data-clarity-unmask="true" />
  </ng-template>
</p-dialog>

<app-question-details
  [(detailsControl)]="detailsControl"
  [question]="question"
  [questionList]="detailsQuestionList"
  [questionIndex]="questionIndex"
  (inicializeQuestionList)="inicializeQuestionList()"
></app-question-details>
